// Step3.js
import { createVeriffFrame, MESSAGES } from '@veriff/incontext-sdk';
import { Veriff } from '@veriff/js-sdk';
import React, { useEffect, useMemo, useState } from 'react';
import { getVeriffStatus } from '../../utils/Api';
import { ToastProvider, useToast } from '../common/RemitAssureToast';
import { Alert } from 'react-bootstrap';

const VeriffComp = ({ forward, setVeriffStatus, values }) => {

  const [loading, setLoading] = useState(false)
  const [re_verify, setReverify] = useState(false);
const {showToast}=useToast();
  const local = useMemo(() => (
    JSON.parse(sessionStorage.getItem("remi-user-dt"))
  ), sessionStorage.getItem("remi-user-dt"))

  useEffect(() => {
    if (local || values) {
      const veriff = Veriff({
        apiKey: `${process.env.REACT_APP_VERIFF_KEY}`,
        parentId: 'veriff-root',
        onSession: function (err, response) {
          createVeriffFrame({
            url: response.verification.url,
            onEvent: function (msg) {
              setReverify(false)
              switch (msg) {
                case MESSAGES.CANCELED:
                  setLoading(false)
                  break;
                case MESSAGES.STARTED:
                  setReverify(false)
                  break;
                case MESSAGES.FINISHED:
                  setLoading(true)
                  setReverify(false)
                  let intervalCleared = false;
                  const interval = setInterval(() => {
                    getVeriffStatus({ session_id: response.verification.id })
                  }, 5000)
                  setTimeout(() => {
                    if (!intervalCleared) {
                      setLoading(false);
                      clearInterval(interval);
                      setVeriffStatus("submitted")
                      forward()
                    }
                  }, 10 * 1000)
                  function clearIntervalAndExecute(status, message = "") {
                    intervalCleared = true;
                    setLoading(false);
                    clearInterval(interval);
                    if (message) {
                      setReverify(message);
                    } else if (status === "approved") {
                      forward()
                    }
                  }
                  break;
              }
            }
          });
          if (err) {
            showToast('error','Error',err?.message)
          }
        }
      });
      veriff.setParams({
        vendorData: `${local?.customer_id}`,
        person: {
          givenName: `${local?.First_name || values?.First_name}`,
          lastName: `${local?.Last_name || values?.Last_name}`
        }
      });
      veriff.mount({
        formLabel: {
          givenName: 'First name',
          lastName: 'Last name',
          vendorData: 'Unique id/Document id'
        },
        submitBtnText: 'Verify Your ID',
        loadingText: 'Processing...'
      })
    }

  }, [values])

  return (
    <>
      {
        loading && (
          <>
            <div className="loader-overly" style={{ background: "rgb(0 0 0 / 85%)" }}>
              <div className="loader">
              </div>
              <div className="loader-text">
                <p className='get-text' >Please wait while we are verifying your identity..</p>
              </div>
            </div>
          </>
        )
      }
      <div>
        <section className="kyc">
          <div className="">
            <div className="">
              <div className="row each-row">
                <div className='col-md-12'>
                  <div id='veriff-root' style={{ margin: "auto", padding: "25px 0px" }}>
                  </div>
                </div>
              </div>
              <div className="next-step dashbord">
                {
                  re_verify && (
                    <Alert className='kyc_alert' >
                      <span>{re_verify}</span>
                    </Alert>
                  )
                }
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  )
};

export default VeriffComp;
